module.exports = __webpack_public_path__ + "img/ic-mobile-border.a01c9864.svg";